export const positiveFactorsList = [
  'Same line of work (as previous employer)',
  'Length of time with current employer (18-24 Months)',
  'Length of time with previous employer (2 or more years)',
  'Unused additional current income',
  'Previous history of variable income (when the borrower doesn’t have 24 most recent months of variable income)',
  'Type of Business (in demand such as nurse income)',
  'No gaps in employment (Less than 30 day gap)',
  'Schooling/Training was completed for current position',
  'History of multiple jobs earning the same additional type of job. (Tip income from 3 different jobs for the last 23 months)',
  'Consistent increases from oldest to most current employer for overall income',
];

export const FHA_QUALIFYING_INCREASING_TREND =
  'QualifyingVariableIncomeIncreasingTrend';

export const FHA_24_MONTH_CALCULATION_HEADER = ' 24 Month Calculation';
